import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services'
var localizedData = [];
class DropDownCell extends Component {

  componentDidMount() {
    (async () => {
      const data = {}
      const ArtigosService = await services.apiCall.requestApi(
        "/Receita/GetArtigos",
        data,
        "get"
      );
      if (localizedData.length == 0 ){
        ArtigosService.map((tipo) => (
          localizedData.push({text: tipo.codArtigo, value: tipo.iva + "!" + tipo.idArtigo + "!" + tipo.valorUnitario, descricao: tipo.descricao})
  
        ));
      }

    })();
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
  });
  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    return (
        <td>
            {dataItem.inEdit ?
            <DropDownList
              popupSettings={{
                width: 'max-content',
              }}
              onChange={this.handleChange}
              value={localizedData.find(c => c.value === (dataValue != null ? dataValue.value != null ? dataValue.value :dataValue : null))}
              data={localizedData}
              textField="text"
              id='id-DropDownCellArtigos'
            />
            : dataValue != null ? dataValue.text.toString() : undefined}
        </td>
    );
  }
    
}

export default DropDownCell;
// import * as React from 'react';
// import { DropDownList } from '@progress/kendo-react-dropdowns';
// import services from '../../../services';
// export const DropDownCell = props => {

// const localizedData = [];
// myFunction()
// function myFunction() {
//     (async () => {
//     const data = {}
//         const ArtigosService = await services.apiCall.requestApi(
//            "/Receita/GetArtigos",
//            data,
//            "get"
//         );

//     for (let index = 0; index < ArtigosService.length; index++) {
//         const iva = ArtigosService[index].iva;
//         const descricao = ArtigosService[index].descricao;
//         const idArtigo = ArtigosService[index].idArtigo
//         const valorUnitario = ArtigosService[index].valorUnitario

//         let object = {text: descricao, value:iva + "!" + idArtigo + "!" + valorUnitario }

//        localizedData.push(object)
//     }

//         console.log("QUERO SABER MyDrop", localizedData)
//  })();};

    
//   const handleChange = e => {
//     if (props.onChange) {
//       props.onChange({
//         dataIndex: 0,
//         dataItem: props.dataItem,
//         field: props.field,
//         syntheticEvent: e.syntheticEvent,
//         value: e.target.value
//       });
//     }
    
//   };

//   const {
//     dataItem
//   } = props;
//   const field = props.field || '';
//   const dataValue = dataItem[field] === null ? '' : dataItem[field];
  
//   // $(".valorUnitarioFill").text(dataValue.value.split("!")[2])
//   return <td>
//         {dataItem.inEdit ? <DropDownList style={{
//     }} onChange={handleChange} value={localizedData.find(c => c.value === dataValue)} data={localizedData} textField="text" required /> : dataValue.text.toString()}
//       </td>;;
// };

// // export const DropDownCell = props => {
   
// //     const localizedData = [];

// // //    componentDidMount = () => {
    
// // //         (async () => {
// // //             const datapagamento = {}
// // //                 const TipoPagamento = await services.apiCall.requestApi(
// // //                    "/Receita/GetTipoPagamento",
// // //                    datapagamento,
// // //                    "get"
// // //                 );
    
// // //             for (let index = 0; index < TipoPagamento.length; index++) {
// // //                 const idTipoPagamento = TipoPagamento[index].idTipoPagamento;
// // //                 const descricao = TipoPagamento[index].descricao;

// // //                 let object = {text: descricao, Value:idTipoPagamento}

// // //                 localizedData => localizedData.concat(object) 
// // //             }
    
// // //                 console.log("QUERO SABER MyDrop", this.state.localizedData)
// // //          })();
// // //     }   
// //     // const handleChange = e => {
// //     //     if (props.onChange) {
// //     //       props.onChange({
// //     //         dataIndex: 0,
// //     //         dataItem: props.dataItem,
// //     //         field: props.field,
// //     //         syntheticEvent: e.syntheticEvent,
// //     //         value: e.target.value.value
// //     //       });
// //     //     }
// //     //   };
    
// //     //   const {
// //     //     dataItem
// //     //   } = props;
// //     //   const field = props.field || '';
// //     //   const dataValue = dataItem[field] === null ? '' : dataItem[field];
// //     //   return <td>
// //     //         {dataItem.inEdit ? <DropDownList style={{
// //     //       width: "100px"
// //     //     }} onChange={handleChange} value={localizedData.find(c => c.value === dataValue)} data={localizedData} textField="text" /> : dataValue.toString()}
// //     //       </td>;
// // }; 
  